import { useState, useEffect } from 'react';

/**
 * Hook para detectar se o dispositivo é desktop ou mobile
 *
 * Utiliza window.matchMedia para detectar o tipo de dispositivo baseado
 * na largura da tela. Considera desktop qualquer dispositivo com largura
 * maior que 768px.
 *
 * @returns {boolean} true se for desktop, false se for mobile
 *
 * @example
 * const isDesktop = useDeviceDetection();
 */
export const useDeviceDetection = () => {
  const [isDesktop, setIsDesktop] = useState(
    window.matchMedia('(min-width: 769px)').matches,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 769px)');

    const handleChange = (e) => {
      setIsDesktop(e.matches);
    };

    // Adiciona listener para mudanças
    mediaQuery.addEventListener('change', handleChange);

    // Cleanup
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return isDesktop;
};
